import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Stats from "@/components/site/Stats";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import CtaBanner from "@/components/site/CtaBanner";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-[#050505] text-white overflow-x-hidden">
      <Header />
      <Hero />
      <About />
      <Services />
      <Stats />
      <Process />
      <Testimonials />
      <CtaBanner />
      <Contact />
      <Footer />
    </main>
  );
}
